import { FC, Fragment, useState } from 'react';
import { Button } from '@servicetitan/design-system';
import { OutboundCallModalProvider } from '../OutboundCallModal';
import OutboundCallModal from '../OutboundCallModal/OutboundCallModal';
import { OutboundCallDetails } from '../OutboundCallModal/types';
import { TechnicianConfirmationModal } from './TechnicianConfirmationModal';
import { mainLayoutLocators } from '@locators/main-layout';
import { FeatureErrorBoundary } from '@components/ErrorBoundary';

export const OutboundCallButton: FC = () => {
  const [showOutboundCallModal, setShowOutboundCallModal] = useState(false);
  const [technicianDetails, setTechnicianDetails] =
    useState<OutboundCallDetails | null>(null);

  const toggleOutboundCallModal = () => {
    setShowOutboundCallModal((state) => !state);
  };

  const handleTechnicianNext = (details: OutboundCallDetails) => {
    setTechnicianDetails(details);
  };

  const handleTechnicianConfirmClose = () => {
    setTechnicianDetails(null);
  };

  const showModal = showOutboundCallModal || !!technicianDetails;

  return (
    <Fragment>
      <Button
        id={mainLayoutLocators.navBar.callBtnIcon}
        iconName='phone_outbound'
        outline
        size='small'
        width='full'
        onClick={toggleOutboundCallModal}
      >
        Make a Call
      </Button>

      {showModal && (
        <FeatureErrorBoundary featureName='Outbound Call Modal' size='full'>
          <OutboundCallModalProvider>
            <OutboundCallModal
              open={showOutboundCallModal}
              setOpen={setShowOutboundCallModal}
              showTenantSelection
              onTechnicianNext={handleTechnicianNext}
            />
            {technicianDetails && (
              <TechnicianConfirmationModal
                details={technicianDetails}
                onClose={handleTechnicianConfirmClose}
              />
            )}
          </OutboundCallModalProvider>
        </FeatureErrorBoundary>
      )}
    </Fragment>
  );
};
